var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4637 9.9988C13.0333 9.9988 15.1164 7.88048 15.1164 5.2674C15.1164 2.65433 13.0333 0.536011 10.4637 0.536011C7.89411 0.536011 5.81104 2.65433 5.81104 5.2674C5.81104 7.88048 7.89411 9.9988 10.4637 9.9988Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25553 19.4618H2.88632C1.9159 19.4618 1.15154 18.5696 1.33764 17.603C2.18842 13.2704 5.95043 9.99902 10.4635 9.99902C14.9766 9.99902 18.7386 13.2637 19.5894 17.603C19.7822 18.5696 19.0111 19.4618 18.0407 19.4618H16.605",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4638 13.8856L11.8796 16.8056L15.05 17.2719L12.7569 19.543L13.302 22.7536L10.4638 21.2396L7.63235 22.7536L8.17073 19.543L5.88428 17.2719L9.04809 16.8056L10.4638 13.8856Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationBlue);
export default __webpack_public_path__ + "static/media/DesignationBlue.da870b66b7cec312328f9a66b3abb1e5.svg";
export { ForwardRef as ReactComponent };